import { fetchPatchVdaAction } from "./actions";
import {
  getVdaActions,
  getVdaActionsStatus,
  getVdaActionsError,
  getVdaActionById,
  getIsVdaActionsLoaded,
  getIsVdaActionsLoading,
  getIsVdaActionsLoadingError,
} from "./selectors";
import VdaActionsSlice from "./reducers";

// actions
export const {
  resetVdaActions,
  setVdaActions,
  addVdaAction,
  updateVdaAction,
  removeVdaAction,
} = VdaActionsSlice.actions;

// async actions
export { fetchPatchVdaAction };

// selectors
export {
  getVdaActions,
  getVdaActionsStatus,
  getVdaActionsError,
  getVdaActionById,
  getIsVdaActionsLoaded,
  getIsVdaActionsLoading,
  getIsVdaActionsLoadingError,
};

// reducer
export default VdaActionsSlice.reducer;
